module.exports = __webpack_public_path__ + "img/icon-truck.f3710e21.svg";